module.exports = __webpack_public_path__ + "img/cup.bb81bf50.png";